export class CorporateSavingsPlanModel {
    // Identity Details
    lastName: string;
    firstName: string;
    otherNames?: string;
    Gender: string;
    Status: string;
    Nationality: string;
    Resident: string;
    ID: string; 
    DateofIssue: Date;
    DateofExpiry: Date;
    IdentificationNo: string;
    IdentityFile:string;
    Bvn: string;
    Nin: string;
    Email: string;
  
    // Address Details
    Address: string;
    City: string;
    State: string; 
    Country: string;
    Tel: string;
    Occupation: string;
    PA: string; 
    AddressFile: string;
  
    // Policy Details
    Contribution: string;
    Risk: string;
    Source: string;
    Duration: string;
    Payment: string;
    Mode: string;
    Specify: string;
  
    // Other Details
    GrossAnnualIncome: string; // Gross income enum value
    Employer: string;
    Designation: string;
    Long: string; // How long in employment (could be number of years if applicable)
    Premium: number;
    EmploymentStatus: string;
    EmploymentStatusOther: string;
    EmployerName: string;
    EmployerAdd: string;
    BankName: string;
    AccountNo: string;
    Type: string;
    Appl?: string;
    info?: string;
  
    // Beneficiary
    PrimaryName: string;
    BeneficiaryRelationship: string;
    ContingentName: string;
    ContingentRelationship: string;
  
    // Reference One
    ReferenceName: string;
    ReferenceOccupation: string;
    ReferenceAddress: string;
    ReferenceMobileNo: string;
  
    // Reference Two
    ReferenceOtherName: string;
    ReferenceOtherOccupation: string;
    ReferenceOtherAddress: string;
    ReferenceOtherMobileNo: string;
  
    // Declaration
    proposalConfirm: boolean;
    declarantName: string;
    declarationDate: Date;
  
    // Agent Details
    AMCName: string;
    AgentCode: string;
    AgentEmail: string;
  

    consentName: string;
    consentDate: Date;
    consentAddress: string;
  }
  